import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "input-box-wrapper" }
const _hoisted_3 = { class: "open-input-box" }
const _hoisted_4 = ["placeholder", "rows"]
const _hoisted_5 = {
  key: 0,
  class: "file-preview"
}
const _hoisted_6 = { class: "action-buttons" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "pdf-preview"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "icons" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "file-preview"
}
const _hoisted_16 = { class: "action-buttons" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "pdf-preview"
}
const _hoisted_22 = { class: "wrapper" }
const _hoisted_23 = { class: "input-box-wrapper" }
const _hoisted_24 = { class: "open-input-box" }
const _hoisted_25 = ["placeholder", "rows"]
const _hoisted_26 = { class: "icons" }
const _hoisted_27 = ["innerHTML"]

import {
  computed,
  ref,
  onMounted,
  watch,
  shallowRef,
  PropType,
  toRefs,
  onBeforeUnmount,
} from "vue";
import router from "@/router";
import { getIcon } from "@/helpers/api";
import CssUtils from "@/helpers/cssUtils";
import { IFont, getFont } from "@/helpers/fonts";
import { nanoid } from "nanoid";
import { useOpenInputMediaStore } from "@/modules/a.worksheets/stores/openInputMediaStore";
import { useDeviceStatus } from "@/stores/deviceStatus";
import WksOpenInputPopUpBtn from "@/modules/a.worksheets/views/components/footer/WksOpenInputPopUpBtn.vue";
import WksOpenInputBtn from "@/modules/a.worksheets/views/components/footer/WksOpenInputBtn.vue";
import { TInputButton } from "@/modules/a.worksheets/helpers/wksOpenInput";
import { RouteParamsRaw } from "vue-router";
import { SolutionData, useWorksheetHandler } from '@/globals/helpers/worksheetHandler';
import { modalController } from "@ionic/vue";
import WksMediaModal from "@/globals/components/WksMediaModal.vue";
import PdfViewer from "@/globals/components/PdfViewer/PdfViewer.vue";

interface MediaPayload {
  text: string;
  files: File[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WksOpenInputOneFile',
  props: {
  mediaButton: {
    type: Array as PropType<TInputButton[]>,
    default: () => [],
  },
  placeholder: { type: String, default: "" },
  textBtn: {
    type: Object as PropType<{ src: string; route: string }>,
    default: () => ({}),
  },
  isText: { type: Boolean, default: true },
  params: { type: Object as PropType<RouteParamsRaw>, default: () => ({}) },
},
  emits: ["set-media"],
  setup(__props, { emit: __emit }) {

const { isWeb } = toRefs(useDeviceStatus());

const isOptionsBoxOpen = ref(false);
const props = __props;

const emit = __emit;

const modifiedButtons = ref<
  Array<{
    route: string;
    src: string;
    svg: string;
    name: string;
    routeName: string;
  }>
>();
const inputRef = shallowRef<HTMLTextAreaElement | null>(null);

const nore12 = ref<IFont>();
const nore16 = ref<IFont>();



const plusSvg = ref<string | undefined>();
const uploadSvg = ref<string | undefined>();
const sendSvg = ref<string | undefined>();
const deleteSvg = ref<string | undefined>();
const expand = ref<string>();
const leftArrow = ref<string>();
const rightArrow = ref<string>();

onMounted(async () => {
  leftArrow.value = await getIcon("1602", "previous_page");
  rightArrow.value = await getIcon("1602", "next_page");
  deleteSvg.value = await getIcon("2105", "bin");
  plusSvg.value = await getIcon("1602", "plus");
  expand.value = await getIcon("1602", "expand");
  uploadSvg.value = await getIcon("2101", "upload");
  nore12.value = await getFont("nore12");
  nore16.value = await getFont("nore16");
  const sendBlobUrl = await getIcon("1610A", "send");
  if (sendBlobUrl) {
    sendSvg.value = await fetch(sendBlobUrl).then((r) => r.text());
  }
});

function route(path: string) {
  isOptionsBoxOpen.value = false;
  router.replace(path);
}

const pageNumbers = ref<Record<string, number>>({});

const setPageNr = (key: string, newPage: number) => {
  pageNumbers.value[key] = newPage;
};

const getInputCSS = computed(() => {
  const backgroundColor = isWeb.value
    ? "var(--worksheet-difficulty-bg)"
    : "#EFEFEF";
  return {
    "--placeholder-font": isWeb.value
      ? nore16.value?.["font-family"]
      : nore12.value?.["font-family"],
    "--placeholder-font-size": isWeb.value
      ? nore16.value?.["font-size"]
      : nore12.value?.["font-size"],
    "--placeholder-font-weight": isWeb.value
      ? nore16.value?.["font-weight"]
      : nore12.value?.["font-weight"],
    "--placeholder-transform": isWeb.value
      ? nore16.value?.["text-transform"]
      : nore12.value?.["text-transform"],
    "--input-background": backgroundColor,
  };
});

const setInputText = (e: InputEvent) =>
  (text.value = e.target ? (e.target as HTMLTextAreaElement).value : "");

const text = ref("");


const selectedFile = ref<File | null>(null);
const filePreview = ref<{ url: string; type: string } | null>(null);

function isImage(type: string): boolean {
  return ['image/png', 'image/jpeg', 'image/jpg'].includes(type);
}

function isPDF(type: string): boolean {
  return type === 'application/pdf';
}

async function sendMedia() {
  if (selectedFile.value || text.value.trim() !== "") {
    const payload: MediaPayload = {
      text: text.value.trim(),
      files: selectedFile.value ? [selectedFile.value] : []
    };

    // Determina o tipo com base nos arquivos
    let type: SolutionData;
    if (selectedFile.value) {
      type = isPDF(selectedFile.value.type) ? "pdf" : "image";
    } else {
      type = "text";
    }

    emit("set-media", payload, type);

    if (inputRef.value) inputRef.value.value = "";
    text.value = "";
    removeFile();
  }
}


async function processDocument() {
  if (inputElement.value && inputElement.value.files) {
    const file = inputElement.value.files[0];
    console.log("file.type", file.type);
    inputElement.value.value = '';

    if (isImage(file.type) || isPDF(file.type)) {
      selectedFile.value = file;
      const url = URL.createObjectURL(file);
      filePreview.value = { url, type: file.type };
    } else {
      console.error("Formato de ficheiro não suportado para pré-visualização.");

    }
  }
}


function removeFile() {
  if (filePreview.value) {
    URL.revokeObjectURL(filePreview.value.url);
  }
  selectedFile.value = null;
  filePreview.value = null;
}


const canSend = computed(() => {
  return (text.value.trim().length > 0) || (selectedFile.value !== null);
});

watch(selectedFile, (newFile, oldFile) => {
  if (oldFile && filePreview.value) {
    URL.revokeObjectURL(filePreview.value.url);
    filePreview.value = null;
  }
});

onBeforeUnmount(() => {
  if (filePreview.value) {
    URL.revokeObjectURL(filePreview.value.url);
  }
});

const id = nanoid();

const openInputMediaStore = useOpenInputMediaStore();
watch(openInputMediaStore.openInput, (mapping) => {
  const data = mapping.get(id);
  if (data) {
    if (typeof data.data === 'boolean') {
      console.error("WksOpenInput Caught boolean data from the Store! Not supported inside the code");
      return;
    }

    const payload: MediaPayload = {
      text: '',
      files: []
    };

    if (typeof data.data === 'string') {
      payload.text = data.data;
    } else if (Array.isArray(data.data)) {
      payload.files = data.data;
    }

    emit("set-media", payload, data.type);
    console.log("WksOpenInput Caught data from the Store!", data);
  }
});

const openMediaModal = async () => {
  if (!filePreview.value || !isImage(filePreview.value.type)) return;

  const modal = await modalController.create({
    component: WksMediaModal,
    componentProps: {
      files: [{
        source: filePreview.value.url,
        type: filePreview.value.type,
      }],
      index: 0,
    },
    cssClass: ["wks-media-modal"],
  });
  await modal.present();
};
const textAreaRows = ref<number>(5);

function shrinkArea(e: FocusEvent) {
  setTimeout(() => {
    textAreaRows.value = 1;
  }, 100);
}

function openRoute(name: string, params: RouteParamsRaw) {
  router.push({
    name,
    params,
  });
}

const inputElement = ref<HTMLInputElement | null>(null);
async function fsSelectFile() {
  if (inputElement.value) {
    inputElement.value.click()
  }
}


return (_ctx: any,_cache: any) => {
  return (_unref(isWeb))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "flexbox relative",
        style: _normalizeStyle(getInputCSS.value)
      }, [
        _createElementVNode("input", {
          type: "file",
          hidden: "",
          ref_key: "inputElement",
          ref: inputElement,
          accept: "application/pdf, image/jpeg, image/png",
          onChange: processDocument
        }, null, 544),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
                placeholder: __props.placeholder,
                ref_key: "inputRef",
                ref: inputRef,
                rows: textAreaRows.value
              }, null, 8, _hoisted_4), [
                [_vModelText, text.value]
              ])
            ])
          ])
        ]),
        (filePreview.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: deleteSvg.value,
                  class: "action-button remove-button",
                  onClick: removeFile,
                  alt: "Remover Arquivo"
                }, null, 8, _hoisted_7),
                (isImage(filePreview.value.type))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: expand.value,
                      class: "action-button expand-button",
                      onClick: openMediaModal,
                      alt: "Expandir Imagem"
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              (isImage(filePreview.value.type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: filePreview.value.url,
                      alt: "Pré-visualização de Imagem"
                    }, null, 8, _hoisted_10)
                  ]))
                : (isPDF(filePreview.value.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("embed", {
                        src: filePreview.value.url,
                        type: "application/pdf",
                        width: "100%",
                        height: "200px"
                      }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(WksOpenInputBtn, {
            src: uploadSvg.value,
            "route-name": "file",
            onClick: fsSelectFile
          }, null, 8, ["src"]),
          _createVNode(_Transition, { name: "send" }, {
            default: _withCtx(() => [
              (canSend.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "send-button",
                    onClick: sendMedia,
                    innerHTML: sendSvg.value
                  }, null, 8, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ], 4))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "flexbox relative",
        style: _normalizeStyle(getInputCSS.value)
      }, [
        (filePreview.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                  src: deleteSvg.value,
                  class: "action-button remove-button",
                  onClick: removeFile,
                  alt: "Remover Arquivo"
                }, null, 8, _hoisted_17),
                (isImage(filePreview.value.type))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: expand.value,
                      class: "action-button expand-button",
                      onClick: openMediaModal,
                      alt: "Expandir Imagem"
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              (isImage(filePreview.value.type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("img", {
                      src: filePreview.value.url,
                      alt: "Pré-visualização de Imagem"
                    }, null, 8, _hoisted_20)
                  ]))
                : (isPDF(filePreview.value.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(PdfViewer, {
                        source: filePreview.value!.url,
                        page: pageNumbers.value[filePreview.value!.url] || 1,
                        onPageChanged: _cache[1] || (_cache[1] = newPage => setPageNr(filePreview.value!.url, newPage))
                      }, null, 8, ["source", "page"])
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((text).value = $event)),
                placeholder: __props.placeholder,
                ref_key: "inputRef",
                ref: inputRef,
                rows: textAreaRows.value
              }, null, 8, _hoisted_25), [
                [_vModelText, text.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("input", {
              class: "input-button",
              type: "file",
              hidden: "",
              ref_key: "inputElement",
              ref: inputElement,
              accept: "application/pdf, image/jpeg, image/png",
              onChange: processDocument
            }, null, 544),
            _createVNode(WksOpenInputBtn, {
              src: uploadSvg.value,
              "route-name": "file",
              onClick: fsSelectFile
            }, null, 8, ["src"]),
            _createVNode(_Transition, { name: "send" }, {
              default: _withCtx(() => [
                (canSend.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "send-button",
                      onClick: sendMedia,
                      innerHTML: sendSvg.value
                    }, null, 8, _hoisted_27))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ], 4))
}
}

})